<template>
  <div>
    <b-dropdown
      ref="dropdown"
      size="sm"
      variant="outline-primary"
      toggle-class="btn-sm d-flex align-items-center"
      menu-class="dropdown-menu-tags"
      :auto-close="false"
      @shown="$emit('dropdown-opened')"
    >
      <template #button-content>
        <feather-icon
          icon="PlusIcon"
          size="14"
          class="mr-1"
        /> Etiquetas
      </template>
      <b-dropdown-form @submit.stop.prevent>
        <b-form-group
          label="Buscar etiquetas"
          label-for="tag-search-input"
          label-cols-md="auto"
          class="mb-0"
          label-size="sm"
          :description="searchDesc"
        >
          <b-form-input
            id="tag-search-input"
            v-model="search"
            type="search"
            size="sm"
            autocomplete="off"
            aria-label="Buscar etiquetas"
            placeholder="Buscar etiquetas..."
          />
        </b-form-group>
      </b-dropdown-form>

      <b-dropdown-divider />

      <div class="tag-scroll-list">
        <b-dropdown-item
          v-for="(option, index) in availableOptions"
          :key="`tag-${index}-${option.nome}`"
          @click="onOptionClick(option.nome)"
        >
          <span
            class="tag-color-indicator mr-2"
            :style="{ backgroundColor: option.cor }"
          />
          {{ option.nome }}
        </b-dropdown-item>
      </div>

      <b-dropdown-text v-if="availableOptions.length === 0 && !search">
        Nenhuma etiqueta disponível
      </b-dropdown-text>

      <b-dropdown-divider v-if="availableOptions.length > 0" />

      <b-dropdown-item @click="abrirModalNovaTag">
        <feather-icon icon="PlusIcon" size="14" class="mr-1" />
        Criar nova etiqueta
      </b-dropdown-item>
    </b-dropdown>

    <!-- Modal para criar nova etiqueta -->
    <b-modal
      v-model="modalNovaTagVisivel"
      title="Criar Nova Etiqueta"
      size="sm"
      @ok="criarNovaTag"
      ok-title="Criar"
      cancel-title="Cancelar"
      ok-variant="success"
    >
      <b-form-group
        label="Nome da etiqueta"
        label-for="nova-tag-nome"
      >
        <b-form-input
          id="nova-tag-nome"
          v-model="novaTagNome"
          placeholder="Digite o nome da etiqueta..."
          maxlength="30"
          autofocus
        />
        <small class="text-muted">{{ novaTagNome.length }}/30 caracteres</small>
      </b-form-group>

      <b-form-group
        label="Cor da etiqueta"
        label-for="nova-tag-cor"
      >
        <b-form-input
          id="nova-tag-cor"
          v-model="novaTagCor"
          type="color"
          style="max-width: 100px;"
        />
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import {
  BDropdown,
  BDropdownForm,
  BDropdownItem,
  BDropdownDivider,
  BDropdownText,
  BFormInput,
  BFormGroup,
  BButton,
  BModal,
} from 'bootstrap-vue'
import { createTag } from '../../functions/basics/chat'

export default {
  name: 'CampoTags',
  components: {
    BDropdown,
    BDropdownForm,
    BDropdownItem,
    BDropdownDivider,
    BDropdownText,
    BFormInput,
    BFormGroup,
    BButton,
    BModal,
  },
  props: {
    value: Array,
    tagsDisponiveis: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      search: '',
      novaTagCor: '#7367F0',
      novaTagNome: '',
      modalNovaTagVisivel: false,
    }
  },

  computed: {
    criteria() {
      return this.search.trim().toLowerCase()
    },
    availableOptions() {
      return this.tagsDisponiveis
        .filter(opt => !this.value.includes(opt.nome))
        .filter(opt => !this.criteria || opt.nome.toLowerCase().includes(this.criteria))
    },
    searchDesc() {
      return this.criteria && this.availableOptions.length === 0
        ? 'Nenhuma etiqueta corresponde à busca'
        : ''
    },
  },
  methods: {
    abrirModalNovaTag() {
      this.novaTagNome = ''
      this.novaTagCor = '#7367F0'
      this.modalNovaTagVisivel = true
      this.$refs.dropdown.hide()
    },
    async criarNovaTag() {
      if (!this.novaTagNome.trim()) {
        this.$bvToast.toast('Por favor, digite um nome para a etiqueta.', {
          title: 'Atenção',
          variant: 'warning',
          solid: true,
        })
        return
      }

      // Verificar se já existe
      if (this.tagsDisponiveis.some(tag => tag.nome.toLowerCase() === this.novaTagNome.toLowerCase())) {
        this.$bvToast.toast('Já existe uma etiqueta com este nome.', {
          title: 'Atenção',
          variant: 'warning',
          solid: true,
        })
        return
      }

      try {
        await createTag(this.$route.params.uuid, this.novaTagNome, this.novaTagCor)
        
        this.tagsDisponiveis.push({
          nome: this.novaTagNome,
          cor: this.novaTagCor,
        })
        
        this.$emit('input', [...this.value, this.novaTagNome])
        
        this.$bvToast.toast('Etiqueta criada com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          solid: true,
        })
        
        this.modalNovaTagVisivel = false
      } catch (error) {
        this.$bvToast.toast('Erro ao criar etiqueta. Tente novamente.', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        })
      }
    },
    onOptionClick(nome) {
      if (!this.value.includes(nome)) {
        this.$emit('input', [...this.value, nome])
      }
      this.search = ''
    },
  },
}
</script>

<style>
/* Dropdown menu customizado - não-scoped para funcionar */
.dropdown-menu-tags {
  min-width: 250px;
  max-width: 300px;
  padding: 0.5rem;
  font-size: 0.85rem;
}

/* Scroll só na lista de tags, limite de 7 itens (~40px cada) */
.tag-scroll-list {
  max-height: calc(7 * 38px);
  overflow-y: auto;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}

/* Scrollbar suave */
.tag-scroll-list::-webkit-scrollbar {
  width: 6px;
}
.tag-scroll-list::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

/* Bolinha de cor da tag */
.tag-color-indicator {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.1);
  vertical-align: middle;
}
</style>
